import { ClickAwayListener } from "@material-ui/core";
import { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import "./styles.css";

interface IDropdownIconProps {
    onOpen?: () => void;
    onClose?: () => void;
    children: React.ReactNode;
    pulse?: boolean;
    icon: React.ReactNode;
    offset?: number;
}

export default function DropdownMenuIcon(props: IDropdownIconProps) {
    const [show, setShow] = useState(false);
    const [open, setOpen] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div className="dropdown">
            <OverlayTrigger
                overlay={
                    <Tooltip id="tooltip-click">Click para abrir!</Tooltip>
                }
                show={showTooltip}
                placement="auto"
            >
                <div
                    className={`btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg mr-1 ${
                        props.pulse ? " pulse pulse-white " : ""
                    }`}
                    /*id="notification-open-button"*/ onClick={() => {
                        if (!open) {
                            setShow(true);
                            setShowTooltip(false);
                            props.onOpen?.();
                        } else if (!show) {
                            setShowTooltip(true);
                            setTimeout(() => {
                                setShowTooltip(false);
                            }, 2000);
                        }
                        setOpen(!open);
                    }}
                >
                    <span className="svg-icon svg-icon-xl">{props.icon}</span>
                    <span className="pulse-ring"></span>
                </div>
            </OverlayTrigger>

            <div
                className="middle-drop-abs"
                style={{
                    left: props.offset,
                }}
            >
                <div className="middle-drop-rel">
                    <div className="drop-icon-menu-wrapper">
                        <ClickAwayListener
                            mouseEvent="onMouseDown"
                            onClickAway={(e) => {
                                if (open) {
                                    setShow(false);
                                    props.onClose?.();
                                }
                            }}
                        >
                            <div
                                className={`dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg ${
                                    show ? "show" : ""
                                } drop-icon-menu`}
                                x-placement="bottom-end"
                            >
                                {props.children}
                            </div>
                        </ClickAwayListener>
                    </div>
                </div>
            </div>
        </div>
    );
}
